// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3mcrV","fileBtn":"File_fileBtn__3zeVl","closeBtn":"File_closeBtn__1YqeJ","fileSelected":"File_fileSelected__154VC","disabled":"File_disabled__2RF4s"};